import { useOne, useParse } from "@refinedev/core";
import { Breadcrumbs } from "components/breadcrumbs";
import {
  ViewConditionAdditionalSetup,
  ViewConditionSetting,
  ViewPromotionCouponCode,
} from "components/shared/promotion/condition/detail";
import { IPromotionConditionDetail } from "interfaces";
import { endpointService } from "components/shared/services/endpointService";
import { Link } from "react-router-dom";
import Button from "components/button";
import { PencilIcon } from "@heroicons/react/outline";
import { getFormattedDateTime, isHaveActionPermission } from "utills/helpers";
import { HistoryLogButton } from "components/historyLogButton";
import { Label } from "components/label";

export const WPSPromotionConditionDetail: React.FC = () => {
  const parse = useParse();
  const { params } = parse();

  const { data: conditionDetail } = useOne<IPromotionConditionDetail>({
    resource: endpointService.getPromotionEndPoint("getConditionDetail", {
      conditionId: params?.id,
    }),
    id: "",
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const conditionDetailData = conditionDetail?.data ?? null;

  return (
    <div className="wrapper p-4">
      <Breadcrumbs
        additionalLabel={
          <div className="flex items-center gap-x-2.5">
            <HistoryLogButton
              resource={`promotion/conditions/${conditionDetailData?.id}/history`}
              className="w-11 h-11"
            />
            {isHaveActionPermission("condition", "promotion", "edit") ? (
              <div className="flex gap-x-2">
                <Link
                  to={`/promotion/condition/${conditionDetailData?.id}/edit`}
                >
                  <Button>
                    <span className="sr-only">Edit</span>
                    <PencilIcon className="w-4 h-4 text-white" />{" "}
                    <span className="hidden sm:block sm:ml-2">Edit</span>
                  </Button>
                </Link>
              </div>
            ) : (
              <></>
            )}
          </div>
        }
      />
      {conditionDetailData ? (
        <>
          <ViewConditionSetting conditionDetailData={conditionDetailData} />
          <ViewPromotionCouponCode conditionDetailData={conditionDetailData} />
          {/* <ViewConditionAdditionalSetup
            conditionDetailData={conditionDetailData}
          /> */}
          {(conditionDetailData?.created_by ||
            conditionDetailData?.created_at) && (
            <div className="box-container w-full">
              <div className="grid gap-x-4 gap-y-6 text-sm grid-cols-12 lg:gap-x-6">
                <div className="col-span-full sm:col-span-6">
                  <Label id="created_by" name="Created by" />
                  <p>{conditionDetailData?.created_by}</p>
                </div>
                <div className="col-span-full sm:col-span-6">
                  <Label id="created_at" name="Created at" />
                  <p>{getFormattedDateTime(conditionDetailData?.created_at)}</p>
                </div>
              </div>
            </div>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
